import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/utils/api';
import { toast } from 'sonner';
import { useTenant } from '@/contexts/TenantContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { tenantPath } = useTenant();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error('Invalid authentication response');
          navigate(tenantPath('/login'));
          return;
        }
        
        const sessionId = sessionIdMatch[1];
        
        // Exchange session_id for user data
        const response = await api.post('/auth/session', { session_id: sessionId });
        const user = response.data;
        
        // Navigate to dashboard with user data
        navigate(tenantPath('/dashboard'), { state: { user }, replace: true });
        toast.success(`Welcome back, ${user.name}!`);
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Authentication failed. Please try again.');
        navigate(tenantPath('/login'));
      }
    };
    
    processSession();
  }, [navigate, tenantPath]);
  
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[#334155] border-r-transparent"></div>
        <p className="mt-4 text-gray-600">Authenticating...</p>
      </div>
    </div>
  );
}
